import { FEATURES, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'
import store from '@state/store'
import { isWelcomeDismissed } from '@modules/design/utils/welcome-storage'

// Quem tem a feature e já viu o welcome (marcado automaticamente na 1ª visita)
// vai direto para os arquivos; os demais (inclusive público de cross-sell) caem
// no welcome, que segue acessível pela aba "Bem-vindo".
const resolveDriveRedirect = () => {
  const show = store.getters['parameters/show'] || {}
  if (show[FEATURES.AAWZ_DRIVE] && isWelcomeDismissed('aawz-drive')) {
    return { name: 'aawz-drive.files' }
  }
  return { name: 'aawz-drive.welcome' }
}

export default [
  {
    path: '/aawz-drive',
    name: 'aawz-drive',
    // customPermission: libera acesso se o escritório tem FEATURES.AAWZ_DRIVE OU se não tem OCULTAR_CROSS_SELL
    // (mantém a página de boas-vindas acessível como upsell para escritórios sem a contratação).
    meta: {
      customPermission: ({ show }) =>
        !!show[FEATURES.AAWZ_DRIVE] || !show[FEATURES.OCULTAR_CROSS_SELL],
      search: {
        title: 'AAWZ Drive',
        description: 'Arquivos e documentos compartilhados',
        keywords: ['drive', 'arquivos', 'documentos', 'uploads', 'pastas'],
        icon: 'folder-cloud',
        group: SEARCH_GROUPS.FERRAMENTAS,
      },
    },
    redirect: resolveDriveRedirect,
    component: () =>
      lazyLoadView(
        import('@modules/aawz-drive/views/nav-bar/aawz-drive-nav-bar.vue')
      ),
    children: [
      {
        path: 'bem-vindo',
        name: 'aawz-drive.welcome',
        // customPermission: welcome é acessível como upsell quando OCULTAR_CROSS_SELL está ausente;
        // retorna 404 apenas quando OCULTAR_CROSS_SELL=true e o escritório não tem FEATURES.AAWZ_DRIVE.
        meta: {
          customPermission: ({ show }) =>
            !!show[FEATURES.AAWZ_DRIVE] || !show[FEATURES.OCULTAR_CROSS_SELL],
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/aawz-drive/views/welcome/view-aawz-drive-welcome.vue'
            )
          ),
      },
      {
        path: 'arquivos',
        name: 'aawz-drive.files',
        meta: {
          can_show: FEATURES.AAWZ_DRIVE,
          search: {
            title: 'Arquivos do Drive',
            description: 'Navegar e gerenciar arquivos do AAWZ Drive',
            keywords: ['arquivos', 'drive', 'documentos', 'pastas', 'uploads'],
            group: SEARCH_GROUPS.FERRAMENTAS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/aawz-drive/views/files/view-aawz-drive-files.vue')
          ),
      },
    ],
  },
]
